if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      const formData = new FormData(this.form);

      // Frame-Upsell: wenn das Formular ein befuelltes Frame-Input traegt,
      // Print + Rahmen atomar als EIN /cart/add.js-Call (items-Array) senden.
      // Ohne Frame-Input laeuft der FormData-Pfad komplett unveraendert.
      const frameInput = this.form.querySelector('input[data-frame-data]');
      let frameData = null;
      if (frameInput && frameInput.value) {
        try {
          frameData = JSON.parse(frameInput.value);
        } catch (e) {
          frameData = null;
        }
      }
      if (frameData && !frameData.frameId) frameData = null;

      if (frameData) {
        const quantity = Number(formData.get('quantity') || 1);
        const printVariantId = Number(formData.get('id'));
        const printItem = { id: printVariantId, quantity: quantity };
        const printProperties = {};
        let hasPrintProperties = false;
        for (const entry of formData.entries()) {
          const match = entry[0].match(/^properties\[(.+)\]$/);
          if (match) {
            printProperties[match[1]] = entry[1];
            hasPrintProperties = true;
          }
        }
        if (hasPrintProperties) printItem.properties = printProperties;

        const body = {
          items: [
            printItem,
            {
              id: Number(frameData.frameId),
              quantity: quantity,
              properties: {
                _for_variant: String(frameData.printVariantId || printVariantId),
                Werk: frameData.werk || '',
              },
            },
          ],
        };
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = JSON.stringify(body);
      } else {
        delete config.headers['Content-Type'];
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            // Multi-Item-Add ist all-or-nothing: bei 422 (z.B. Rahmen gerade
            // ausverkauft) klare Meldung zeigen und den Rahmen-Swatch loesen,
            // damit der naechste Submit ohne Rahmen durchgeht.
            if (frameData && frameInput) {
              frameInput.value = '';
              frameInput.dispatchEvent(new CustomEvent('frame:deselect'));
            }
            // Shopifys eigene Meldung zuerst: der 422 kann auch vom Werk kommen
            // (z.B. schon in maximaler Menge im Warenkorb). Die Rahmen-Meldung
            // nur als Fallback, sonst wird jeder Fehler dem Rahmen zugeschrieben.
            let errorDescription = response.description;
            if (!errorDescription && frameData) {
              errorDescription = 'Der Rahmen ist gerade nicht verfügbar. Bitte wähle einen anderen Rahmen oder lege das Werk ohne Rahmen in den Warenkorb.';
            }

            // dispatch cart:error
						document.dispatchEvent(
							new CustomEvent('cart:error', {
								detail: {
									source: this.dataset.source,
									productVariantId: formData.get('id'),
									errors: errorDescription,
									message: response.message,
								},
							})
						)
						// dispatch cart:error

            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: errorDescription, message: response.message});
            this.handleErrorMessage(errorDescription);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // Frame-Upsell: Erfolg -> Input leeren, Snippet setzt Auswahl zurueck
          if (frameData && frameInput) {
            frameInput.value = '';
            frameInput.dispatchEvent(new CustomEvent('frame:added'));
          }

          // dispatch variant:add
					document.dispatchEvent(
						new CustomEvent('variant:add', {
							detail: {
								variant: {
									id: formData.get('id'),
								},
								quantity: Number(formData.get('quantity') || 1),
								formElement: this.form,
								sectionId: this.dataset.source,
							},
						})
					)
					// dispatch variant:add

          fetch(`${routes.cart_url}.js`)
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              const parsedState = JSON.parse(state);

              // dispatch cart:change for the entire basket
              document.dispatchEvent(
                new CustomEvent('cart:change', {
                  detail: {
                    cart: parsedState,
                    sectionId: this.dataset.source
                  }
                })
              );
              // dispatch cart:change for the entire basket
            })
            .catch((error) => {
              console.error('Error fetching cart state:', error);
            });

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
